import { Theme } from "@mui/system";

const contactPageStyle = {
  paper: (theme: Theme) => ({
    background: theme.palette.background.light,
  }),
  textSection: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  logoWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  logoBird: (theme: Theme) => ({
    color: theme.palette.brand.steel,
    width: "auto",
    height: { xs: "250px", md: "460px" },
    transform: "scale(1.4) translate( -5%, -16%)",
    transformOrigin: "center left",
  }),
};

export default contactPageStyle;
